import React from 'react';
import '../../../../../less/mobile/index.less';
import MenuItem from '../../../../../views/menuItem.c';
import arrow_down from "../../../../../img/new/mobile/arrow_down.svg";
import abankIcon from "../../../../../img/new/abank-icon.svg";
import { ReactSVG } from 'react-svg';
import SearchInput from '../../../../../views/searchInput.c';
import { loginBtnTypes } from '../../../../../constants.js';

export default function template() {
  const { active, navigate, userTypes, isBusiness, userType, toggle, changeMenu } = this.props;

  const businessMenu = [
    { alias: 'businessCalculations', label: 'HEADER_LINK_BUSINESS_CALCULATIONS', onClick: () => changeMenu('businessCalculations') },
    { alias: 'businessTrade', label: 'HEADER_LINK_BUSINESS_TRADE', onClick: () => changeMenu('businessTrade') },
    { alias: 'businessFreeMoney', label: 'HEADER_LINK_BUSINESS_FREE_MONEY', onClick: () => changeMenu('businessFreeMoney') },
    { alias: 'businessFinancing', label: 'HEADER_LINK_BUSINESS_FINANCING', onClick: () => changeMenu('businessFinancing') },
    { alias: 'businessGov', label: 'HEADER_LINK_BUSINESS_GOV', onClick: () => changeMenu('businessGov') },
    { alias: 'businessABusiness', label: 'HEADER_LINK_BUSINESS_ABUSINESS', url: '/business/abusiness', onClick: toggle },
  ];

  const individualMenu = [
    { alias: 'cards', label: 'HEADER_LINK_CARDS', url: '/cards', onClick: () => changeMenu('cards') },
    { alias: 'deposits', label: 'HEADER_LINK_DEPOSIT', url: '/deposits', onClick: () => changeMenu('deposits') },
    { alias: 'credit', label: 'HEADER_LINK_CREDIT', url: '/credit', onClick: () => changeMenu('credit') },
    { alias: 'business', label: 'HEADER_LINK_BUSINESS', url: '/business', onClick: () => changeMenu('business') },
    { alias: 'services', label: 'HEADER_LINK_SERVICES', url: '/services', onClick: () => changeMenu('services') },
    { alias: 'contacts', label: 'HEADER_LINK_CONNACTS', url: '/contacts', onClick: toggle },
    { alias: 'branches', label: 'HEADER_LINK_BRANCHES', url: '/branches', onClick: toggle },
  ];

  const renderMenuItem = ({ alias, label, url, onClick }) => (
    <MenuItem
      key={alias}
      active={active}
      alias={alias}
      navigate={navigate}
      url={url}
      onClick={onClick}
      allowClickWithoutUrl={isBusiness}
    >
      <div className="module-header-mobile__menu__item">
        {this.l10n(label)}
      </div>
    </MenuItem>
  );

  const menuToRender = isBusiness ? businessMenu : individualMenu;

  const { url: loginUrl, target: loginTarget, text: loginText } =
    isBusiness ? loginBtnTypes.business : loginBtnTypes[active] || loginBtnTypes.default;

  return (
    <div className="module-header-mobile__menu">
      <div className="module-header-mobile__menu__content__main">
        <div className="module-header-mobile__menu__content__main__top">
          <SearchInput navigate={navigate} toggle={toggle}/>
          <div className="module-header-mobile-dropdown">
              <div
                className="module-header-mobile-dropdown__selected"
                onClick={this.toggleUserTypeDropdown}
              >
              <span>{userTypes.find(u => u.tab === userType).name}</span>
              <ReactSVG
                src={arrow_down}
                className={`module-header-mobile-dropdown__arrow${this.state.isUserTypeDropdownOpen ? ' open' : ''}`}
              />
              </div>
              {this.state.isUserTypeDropdownOpen && (
                <div className="module-header-mobile-dropdown__list">
                  {userTypes
                    .filter(u => u.tab !== userType)
                    .map(u => (
                      <div
                        key={u.tab}
                        className="module-header-mobile-dropdown__item"
                        onClick={() => this.changeUserType(u.tab)}
                      >
                        {u.name}
                      </div>
                    ))
                  }
                </div>
              )}
          </div>
          {menuToRender.map(renderMenuItem)}
        </div>
        <a 
          className="mobile-header-a24" 
          href={loginUrl} 
          target={loginTarget} 
          onClick={e => {
            loginTarget === '_self' ? navigate(loginUrl, e) : undefined;
            toggle();
          }}
        >
          <div className="mobile-header-a24__image">
            <img src={abankIcon} alt="abank icon" />
          </div>
          <div className="mobile-header-a24__text">{this.l10n(loginText)}</div>
        </a>
      </div>
    </div>
  );
}
